import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import PricingPlan from "../../../components/pricing/PricingPlan";

const UserMembership = () => {
  return (
    <div>
      <TopHeader tabName={"Upgrade Membership"} />
      <PricingPlan />
    </div>
  );
};

export default UserMembership;
